const TYPE_FORM = {
    COMPANY_VISIT_INPUT: 1,
    IN_HOUSE_MATCH: 2,
    CONNECT_ARRANGEMENT: 3,
    DATE_INPUT: 4,
    INPUT_PARTNER_SELECTION: 5,
    OTHER_HISTORY_TABLE_INPUT: 6,
}

const RESULT_PAYMENT = {
    DEPOSITED: 1,
    NON_PAYMENT: 2
}

const NOT_MEMBER_CUSTOMER = 999999999;
const MEMBER_CONNECT = 999999998;
const MAX_MATCHING_HISTORIES = 5;

const FORMAT_DATE_JP = 'YYYY年MM月DD日'
// type course
const TYPE_COURSE = {
    M_PLATIUM: 1,
    M_GOLD: 2,
    PLATIUM: 3,
    GOLD: 4
}

const COURSE_FEE = {
    M_PLATIUM: 566500,
    M_GOLD: 346500,
    PLATIUM: 583000,
    GOLD: 363000
}


export default {
    TYPE_FORM,
    NOT_MEMBER_CUSTOMER,
    RESULT_PAYMENT,
    MEMBER_CONNECT,
    MAX_MATCHING_HISTORIES,
    FORMAT_DATE_JP,
    TYPE_COURSE,
    COURSE_FEE
}